import { useEffect, useState } from "react";
import { CreditCard } from "lucide-react";
import { api } from "../../lib/api";

// Card photos are private: fetch with admin auth and show as a blob URL.
export const CardThumb = ({ fileId, className = "", testid }) => {
  const [src, setSrc] = useState(null);
  useEffect(() => {
    if (!fileId) return undefined;
    let url = null;
    let alive = true;
    api.get(`/admin/event-cards/${fileId}`, { responseType: "blob" })
      .then((res) => {
        if (!alive) return;
        url = URL.createObjectURL(res.data);
        setSrc(url);
      })
      .catch(() => setSrc(null));
    return () => {
      alive = false;
      if (url) URL.revokeObjectURL(url);
    };
  }, [fileId]);

  if (!src) {
    return (
      <div className={`flex items-center justify-center bg-brand-cream text-brand-charcoal/40 ${className}`}>
        <CreditCard className="h-5 w-5" />
      </div>
    );
  }
  return <img src={src} alt="Business card" data-testid={testid} className={`object-cover ${className}`} />;
};

export default CardThumb;
